import ConversationLink from './conversation_link';
import React            from 'react';


export default function ChatGroups({ businessID, conversationID, userID, users }) {
  if (!users)
    return null;

  const withoutCurrentUser = users.filter(user => user.id !== userID);

  return (
    <div className="team-groups-list list media-list">
      <div className="block-title">Team Members</div>
      {withoutCurrentUser.map(user => {
        const uniqueName = getUniqueName(userID, user.id);
        return (
          <ConversationLink
            selectedConversationID={conversationID}
            key={user.id}
            otherParticipantID={user.id}
            businessID={businessID}
            uniqueName={uniqueName}
            friendlyName={user.name}
          />
        );
      })}
    </div>
  );
}

function getUniqueName(id1, id2) {
  const sortedIDs = [ id1, id2 ].sort().join(':');
  return `users:${sortedIDs}`;
}
